import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Services from '../components/sections/Services';
import SectionDivider from '../components/common/SectionDivider';

const ServicesPage = () => {
  const theme = useTheme();

  return (
    <Box component="main" sx={{ pt: 10 }}>
      <Container maxWidth="lg" sx={{ py: 2 }}>
        <Typography variant="h2" sx={{ 
          mb: 2, 
          fontWeight: 800, 
          textAlign: 'center',
          color: 'primary.main'
        }}>
          Our Services
        </Typography>
        <Typography variant="h6" sx={{ 
          mb: 3, 
          textAlign: 'center',
          color: 'text.secondary',
          maxWidth: 800,
          mx: 'auto'
        }}>
          Comprehensive mechanical contracting solutions for all your HVAC, plumbing, and building automation needs.
        </Typography>
      </Container>
      
      <SectionDivider variant="wave" color="primary.main" mt={1} mb={2} />
      
      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(25,118,210,0.05))` }}>
        <Services />
      </Box>
      
      <SectionDivider variant="line" color="primary.main" mt={6} mb={6} />
      
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
        <Button 
          variant="contained" 
          size="large"
          href="tel:(516) 414-0165"
          sx={{ 
            px: 4, 
            py: 2,
            fontSize: '1.1rem',
            fontWeight: 600
          }}
        >
          Call Now for Service Quote
        </Button>
      </Container>
    </Box>
  );
};

export default ServicesPage;
